<template lang="pug">
.org-search__form
	label.org-search__label(for="search-text") Enter your Organization Name to get started
	.org-search__dropdown-container
		input.org-search__text-input#search-text(
			type="search",
			v-model="searchTerm",
			@input="handleInput($event)",
			@keyup.arrow-down.prevent="shiftHoveredOrg(1)",
			@keyup.arrow-up.prevent="shiftHoveredOrg(-1)",
			@keydown.enter.prevent="selectDefault($event)",
			@keydown.tab="selectDefault($event)"
		)
		.org-search__dropdown-options(
			v-if="!!searchTerm && !selectedOrg"
		)
			.org-search__dropdown-option(
				v-for="(org, index) in filteredOrgs",
				v-if="index < 10",
				:key="org.id",
				:class="{hovered: index == hoveredOrgIndex}",
				@click="selectOrg($event, org)",
				@mouseover="setHoveredOrg(index)"
			) {{ org.name }}
			.org-search__dropdown-option.more(
				v-if="filteredOrgs.length > 9"
			) ...
			.org-search__dropdown-option.none(
				v-if="filteredOrgs.length == 0"
			) There are no items matching your search...
	a.org-search__submit.btn(
		target="_blank",
		:href="selectedOrg?selectedOrg.url:''",
		:disabled="!selectedOrg",
		@keydown.enter="submitEnterPress($event)"
	) Report a Claim
</template>

<script>
export default {
	name: "SearchForm",
	props: {
		orgList: Array,
		userDistrictId: String,
	},
  data() {
    return {
			searchTerm: "",
			hoveredOrgIndex: null,
			selectedOrg: null, 
    };
  },
	computed: {
		filteredOrgs() {
			if (!!this.searchTerm) return this.orgList.filter(org => org.name.toLowerCase().includes(this.searchTerm.toLowerCase()));
			return [];
		},
	},
	methods: {
		shiftHoveredOrg(dir) {
			// Check for up or down arrow that would go outside of dropdown bounds
			if (this.searchTerm == "") return;
			if (this.hoveredOrgIndex == 0 && dir < 0) return;
			if (dir > 0 && (this.hoveredOrgIndex == 9 || this.hoveredOrgIndex == this.filteredOrgs.length - 1)) return;
			if (this.hoveredOrgIndex == null && dir > 0) this.hoveredOrgIndex = 0;
			else this.hoveredOrgIndex += dir;
		},
		setHoveredOrg(index) {
			this.hoveredOrgIndex = index;
		},
		handleInput(e) {
			this.hoveredOrgIndex = null;
			let val = e.target.value;
			let valIsValidName = this.orgList.some(org => org.name == val);
			if (!valIsValidName) this.selectedOrg = null;
		},
		selectOrg(e, org) {
			if (this.selectedOrg && this.selectedOrg.name == this.searchTerm) {
				if (e && e.code == "Enter") this.$el.querySelector("a.org-search__submit.btn").click();
				return;
			};
			this.selectedOrg = org;
			this.searchTerm = this.selectedOrg.name;
			this.hoveredOrgIndex = null;
		},
		selectDefault(e) {
			if (this.hoveredOrgIndex != null) this.selectOrg(null, this.filteredOrgs[this.hoveredOrgIndex]);
			else if (!!this.filteredOrgs.length) this.selectOrg(e, this.filteredOrgs[0]);
		},
		submitEnterPress(e) {
			if (e.target.matches("[disabled]"))	e.preventDefault();
		}
	},
	created() {
		if (!!this.userDistrictId) {
			let matchingIdOrg = this.orgList.find(org => org.id == this.userDistrictId);
			if (!!matchingIdOrg) this.selectOrg(null, matchingIdOrg);
		}
	}
}
</script>

<style lang="scss" scoped>
.org-search {
	&__form {
		display: flex;
		flex-wrap: wrap;
		column-gap: 1.25rem;
	}
	&__label {
		flex: 1 1 100%;
		margin-bottom: 0.5rem;
	}
	&__dropdown-container {
		flex: 1;
		align-self: stretch;
		position: relative;
		@include mqdn(sm_dn) {
			flex: 1 1 100%;
			margin-bottom: 1.5rem;
		}
	}
	&__text-input {
		height: 100%;
		width: 100%;
		padding: 0 0.75rem;
		background: $white;
		position: relative;
		border: solid 1px $darkBlue;
		border-radius: 8px;
		@include mqdn(sm_dn) {
			height: 48px;
		}
	}
	&__dropdown-options {
		position: absolute;
		width: 100%;
		height: auto;
		top: 100%;
		left: 0;
		right: 0;
		background: $white;
		border: solid 1px $black;
		z-index: 2;
	}
	&__dropdown-option {
		padding: 0.625rem 1rem;
		width: 100%;
		max-width: 100%;
		&:not(:last-child) {
			border-bottom: solid 1px $gray;
		}
		&:not([class*=none]):not([class*=more]) {
			cursor: pointer;
			&.hovered {
				background: $blue;
				color: $white;
			}
		}
	}
	&__submit {
		@include mqdn(sm_dn) {
			flex: 1 1 100%;
		}
	}
}
</style>